import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';

export default [
  {
    path: '/funeral',
    component: () => import('@/views/funeral'),
    meta: {
      isHeader: false,
      isNav: true,
      isBack: true,
      titleName: '온라인 장례식장',
      expression: KEEP_ALIVE_OBJECT.FUNERAL.expression,
      isSearchHeader: true
    }
  },
  {
    path: '/funeral/info/:no',
    component: () => import('@/views/funeral/detail.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isGlass: true,
      isFuneralShare: true,
      isFuneralKakaoShare: true,
      expression: KEEP_ALIVE_OBJECT.FUNERAL.expression
    }
  },
  {
    path: '/funeral/wreath/:no',
    component: () => import('@/views/funeral/FuneralChat.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isGlass: false,
      isExcel: true,
      isFuneralShare: true,
      expression: KEEP_ALIVE_OBJECT.FUNERAL.expression
    }
  },
  {
    path: '/funeral/form',
    component: () => import('@/views/funeral/FuneralForm.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '온라인 장례식장 만들기',
      isGlass: false,
      expression: KEEP_ALIVE_OBJECT.FUNERAL.expression
    }
  },
  {
    path: '/funeral/form/:announcementNo',
    component: () => import('@/views/funeral/FuneralForm.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '온라인 장례식장 만들기',
      isGlass: false,
      expression: KEEP_ALIVE_OBJECT.FUNERAL.expression
    }
  }
];
